import { render, staticRenderFns } from "./UserTypeFormDialog.vue?vue&type=template&id=e65dbdcc&scoped=true&"
import script from "./UserTypeFormDialog.vue?vue&type=script&lang=js&"
export * from "./UserTypeFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeFormDialog.vue?vue&type=style&index=0&id=e65dbdcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65dbdcc",
  null
  
)

export default component.exports